import { render } from "./klb-number.vue?vue&type=template&id=60c3d4b6&scoped=true"
import script from "./klb-number.vue?vue&type=script&lang=js"
export * from "./klb-number.vue?vue&type=script&lang=js"

import "./klb-number.vue?vue&type=style&index=0&id=60c3d4b6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c3d4b6"]])

export default __exports__